import { render } from "./Pasori.vue?vue&type=template&id=e3f5e5f6&ts=true"
import script from "./Pasori.vue?vue&type=script&lang=ts"
export * from "./Pasori.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__